import { render, staticRenderFns } from "./RefreshPreco.vue?vue&type=template&id=9af651b4&"
import script from "./RefreshPreco.vue?vue&type=script&lang=js&"
export * from "./RefreshPreco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports